import { useMutation } from '@tanstack/react-query';

import API from '@api/API';

interface FinalizeDynamicEventPayload {
  actionToken: string;
  /** A source event id, or 'dynamic' for the rendered dynamic card */
  imageFromEventId: string;
  tagIds: string[];
  entertainerIds: string[];
}

export const useFinalizeDynamicEventMutation = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (payload: FinalizeDynamicEventPayload) =>
      API.post<{ eventId: string }, FinalizeDynamicEventPayload>(
        '/v1/super-admin/dynamic-events/finalize',
        payload,
      ),
  });

  return {
    isFinalizingDynamicEvent: isPending,
    finalizeDynamicEventAsync: mutateAsync,
  };
};

interface RejectDynamicEventPayload {
  actionToken: string;
  reason: string;
}

export const useRejectDynamicEventMutation = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (payload: RejectDynamicEventPayload) =>
      API.post<{ eventId: string }, RejectDynamicEventPayload>(
        '/v1/super-admin/dynamic-events/reject',
        payload,
      ),
  });

  return {
    isRejectingDynamicEvent: isPending,
    rejectDynamicEventAsync: mutateAsync,
  };
};
